import React, { Fragment, useEffect, useState } from "react";
import BreadCrumb from "../../layout/Breadcrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Input,
  Label,
  Media,
  Badge,
  Button,
} from "reactstrap";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import SuppliesLogo from "../../assets/images/B2BSuppliesLogo.jpg";
import axios from "axios";

const Cotizador = (props) => {
  const { itemID } = useParams();
  const [productoCotizar, setProcutoCotizar] = useState();

  useEffect(() => {
    console.log(itemID);
    if (itemID) {
      getProductoCotizar(itemID);
    }
  }, [itemID]);

  const prestashopAPI = {
    URL: "https://b2bsupplies.net/en/module/b2bsuppliers/B2bApi?",
    token: "OCLTZXD8TIL0NI059XHV8Y39YWYYDWVX",
    type: "Product-ID",
  };
  const getProductoCotizar = async (itemID) => {
    const producto = require("./producto_a_cotizar.json");

    await axios
      .get(
        `${prestashopAPI.URL}token=${prestashopAPI.token}&type=${prestashopAPI.type}&q=${itemID}
       `
      )
      .then((res) => {
        setProcutoCotizar(res.data);
      });
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row className="width-80" style={{ marginLeft: "10%" }}>
          <Col sm="12 p-50">
            <Card>
              <CardHeader>
                {" "}
                <Media
                  className="center-horizontal"
                  style={{ width: "450px" }}
                  src={SuppliesLogo}
                />
              </CardHeader>
              <CardBody>
                <div className={`display-flex`}>
                  <div className="width-30">
                    <h5>Producto a Cotizar:</h5>
                    <hr />
                    <Row className="p-15">
                      <Col sm="12">
                        <Media
                          className="center-horizontal m-t-30"
                          style={{ width: "200px" }}
                          src={productoCotizar?.main_image}
                        />
                        <br />
                        <span className="f-18">
                          <b>{productoCotizar?.name}</b>
                        </span>
                        <br />
                        <Badge color="ligth">
                          <b>{`$ ${parseFloat(productoCotizar?.price).toFixed(
                            "2"
                          )}`}</b>
                        </Badge>
                        <br />
                        <div>
                          <span>{productoCotizar?.description}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className={`child-right width-70`}>
                    <h5>{"Datos de la Cotización:"}</h5>
                    <hr />
                    <Row className="p-15">
                      <Col xl="12">
                        <Label>{"Cantidad"}</Label>
                        <Input type="text" placeholder="Cantidad" />
                      </Col>
                      <Col xl="12">
                        <Label>{"Unidad de Medida"}</Label>
                        <Input type="text" placeholder="Cantidad" />
                      </Col>
                      <Col xl="12">
                        <Label>{"Moneda de cotización"}</Label>
                        <Input type="text" placeholder="Cantidad" />
                      </Col>
                      <Col xl="12">
                        <Label>{"Fecha de videngia de la cotizacion"}</Label>
                        <Input type="date" placeholder="Cantidad" />
                      </Col>
                      <Col xl="12">
                        <Label>{"Descripcion detallada"}</Label>
                        <Input
                          type="textarea"
                          placeholder="Cantidad"
                          rows="3"
                        />
                      </Col>
                      <Col xl="12" className="m-t-15">
                        <div className={`display-flex`}>
                          <div></div>
                          <div className={`child-right`}>
                            <Button
                              color="primary"
                              onClick={() => {
                                alert(
                                  "Cotizacion enviada, entre a https://app.b2buysel.com/ para dar seguimiento a la misma"
                                );
                              }}
                            >
                              {"Cotizar"}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Cotizador;
